import { NotAvailableOnMobile } from "@/components/NotAvailableOnMobile/NotAvailableOnMobile";
import { TrialEndWarning } from "@/components/TrialEndWarning/TrialEndWarning";
import { LayoutWorkstationFullscreen } from "@/components/_layouts/LayoutWorkstationFullscreen/LayoutWorkstationFullscreen";
import { LayoutWorkstationHeader } from "@/components/_layouts/LayoutWorkstationHeader/LayoutWorkstationHeader";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";

export const AppPage = () => {
  //useInitializeLegacyAccount();

  return (
    <LayoutWorkstationFullscreen>
      <TrialEndWarning>
        <LayoutWorkstationHeader header={<Header />}>
          <Outlet />
        </LayoutWorkstationHeader>
      </TrialEndWarning>
      <NotAvailableOnMobile />
    </LayoutWorkstationFullscreen>
  );
};
